import type { TOC } from '@ember/component/template-only';
import lottieAnimation from 'lumen/modifiers/lottie-animation';

interface GeneralLottieAnimationSignature {
  Args: {
    loop: unknown;
    path: unknown;
  };
  Element: HTMLDivElement;
}

const GeneralLottieAnimation = <template>
  {{! @glint-nocheck: not typesafe yet }}
  {{!
Somewhat of a redundant component. You could directly use the lottie animation modifer in other templates.
But for now keeping it as a resource as we dont't use modifiers intensively so you can see the difference between the two.
}}
  <div {{lottieAnimation @path @loop}} ...attributes></div>
</template> satisfies TOC<GeneralLottieAnimationSignature>;

export default GeneralLottieAnimation;
